require('../css/article.css');
import { bindGridSwiper } from './grid-swiper';
const InfiniteScroll = require('infinite-scroll');

window.bindInfiniteScroll = function (isAutoLoad) {
    const container = document.querySelector('.card-infinite .card-body');
    if (!container) return;

    const options = {
        path: params.url + '?page={{#}}',
        append: '.article',
        history: false,
        status: '.page-load-status',
        // MVK-3686: infinite-scroll 5 dùng fetch(), không tự gửi header này; thiếu nó controller trả cả trang thay vì fragment.
        fetchOptions: { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    };
    if (isAutoLoad === false) {
        options.button = '.btn-view-more';
        options.scrollThreshold = false;
    }

    const infScroll = new InfiniteScroll(container, options);

    infScroll.on('history', function () {
        dataLayer.push({
            'event': 'virtualPageView',
            'virtualUrl': location.pathname
        });
    });

    infScroll.on('load', function (response) {
        const text = response.body ? response.body.textContent : '';
        if (!text.trim()) {
            infScroll.destroy();
            const requestEl = document.querySelector('.page-load-status .infinite-scroll-request');
            const lastEl = document.querySelector('.page-load-status .infinite-scroll-last');
            if (requestEl) requestEl.style.display = 'none';
            if (lastEl) lastEl.style.display = '';
        }
    });
}

window.bindGridSwiper = bindGridSwiper;
window.bindGridSlick = bindGridSwiper;
